import { ScreenshotViewer } from '../../custom-components/ScreenshotViewer';
import './SourceTypeBadge.scss';

interface SourceTypeBadgeProps {
  sourceType?: string;
  screenshotKey?: string | null;
}

function formatSourceType(sourceType: string | undefined): string {
  if (!sourceType) return '';
  if (sourceType === 'CRAWLER') return 'Web';
  if (sourceType === 'FOIA') return 'District';
  return sourceType;
}

export function SourceTypeBadge({ sourceType, screenshotKey }: SourceTypeBadgeProps) {
  if (!sourceType) return null;

  // FOIA evidence has no crawl behind it, so never a screenshot even if a key arrived.
  const key = sourceType === 'CRAWLER' ? screenshotKey : null;

  return (
    <span className={`source-type-badge source-type-badge--${sourceType.toLowerCase()}`}>
      {formatSourceType(sourceType)}
      <ScreenshotViewer screenshotKey={key} className="source-type-badge__camera" />
    </span>
  );
}
